export default {
  default: 'auto',
  general: '1',
  dropdown: {
    options: '2',
    options_mobile: '11',
  },
  progressBar: '9',
  nav: '10',
  searchBox: '20',
  tooltip: '12',
  navDrawer: '11',
};
